import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const Smartphone: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['rect', { width: '14', height: '20', x: '5', y: '2', rx: '2', ry: '2' }],
    ['path', { d: 'M12 18h.01' }],
  ],
];

export default Smartphone;
